import { environment } from 'environments/environment';

interface Scripts {
  name: string;
  src: string;
}
export const ScriptStore: Scripts[] = [
  { name: 'anyline', src: '../../assets/anyline-js/anyline.js' },
  { name: 'tesseract', src: '../../assets/tesseract/tesseract.min.js' },
  { name: 'payFrameScript', src: `${environment.payrix_external_script}/payFrameScript` },
  { name: 'payFieldScript', src: `${environment.payrix_external_script}/payFieldsScript` },
  { name: 'Mitchell1', src: `${environment.mitchell1_external_script}` },
  { name: 'OneSignal', src: `${environment.onesignal_external_script}` },
  { name: 'GlobalPayFieldsScript', src: `https://js.paygateway.com/secure_payment/v1/globalpayments.js`},
  { name: 'WorldpacScript', src: '../../assets/speed-dial-script/wcap.sio.02.min.js'},

  // { name: 'GlobalPayFieldsScript', src: '../../assets/globalpayment.js' }
];
